import { render } from "./VToast.vue?vue&type=template&id=5c046dd5&scoped=true"
import script from "./VToast.vue?vue&type=script&lang=js"
export * from "./VToast.vue?vue&type=script&lang=js"

import "./VToast.vue?vue&type=style&index=0&id=5c046dd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c046dd5"]])

export default __exports__